<form [formGroup]="testForm" (ngSubmit)="onSubmit($event)">
  <h3 mat-dialog-title>Новый</h3>
  <div mat-dialog-content>
    <mat-form-field>
      <mat-label>Название теста</mat-label>
      <input matInput formControlName="name" placeholder="Укажите название теста"
             type="text"
             autocomplete="off"
             cdkFocusInitial>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Тип теста</mat-label>
      <mat-select formControlName="type">
        <mat-option value="COMMON">Общий тест</mat-option>
        <mat-option value="HR">HR тест</mat-option>
        <mat-option value="AT">AT тест (тест для отдела автоматизированного тестирования)</mat-option>
        <mat-option value="FT">FT тест (тест для отдела ручного тестирования)</mat-option>
        <mat-option value="TEST">Тестовый (тест для проверки работы стенда (только для команды тестирования!) )</mat-option>
        <mat-option value="POLL">Опрос (опрос для всех направлений компании)</mat-option>
        <mat-option value="ANON">Анонимный опрос (анонимный опрос для всех направлений компании)</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button
            type="button"
            (click)="onCancel()">Отмена
    </button>
    <button mat-button color="primary"
            type="submit"
            (click)="onSubmit($event)">Добавить
    </button>
  </div>
</form>
